import Button from '@material-ui/core/Button';
import React from 'react';
import { Link } from 'react-router-dom';
const ButtonLink = ({ to, ...rest }) => {
    const renderLink = React.useMemo(() => React.forwardRef(({ children, ...linkRest }, ref) => (React.createElement(Link, { ...linkRest, ref: ref, to: to }, children))), [to]);
    return (React.createElement(Button, { ...rest, component: renderLink }, rest.children));
};
export default ButtonLink;
